module.exports = __webpack_public_path__ + "../resources/img/@temp_chart_2.df03f55f.jpg";